var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    panel.classList.toggle("active");
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

jQuery('#slideToPackageChecklist').on('click', function() {
  var offset = jQuery('#packageChecklist').offset();
  jQuery('html, body').animate({
      scrollTop: offset.top + 200
  }, 5);
});